<app-search-list
  [entityDataDispatcher]="trackedTimeDataDispatcher"
  [entityDataStore]="trackedTimeDataStore"
  [headers]="headers$ | async"
  [defaultSearchParams]="defaultSearchParams"
  [noItemsDescriptionKey]="noItemsDescriptionKey"
  [relevancySearchMode]="relevancySearchMode"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName$ | async"
  class="search-list"
>
  <ng-template let-trackedTime="entity" let-position="position">
    <app-tracked-time-list-item
      [trackedTime]="trackedTime"
      [highlights]="highlights$ | async"
      [position]="position"
      [listFilter]="listFilter"
      [displayStatus]="true"
      (onAction)="onQuickAction($event, trackedTime)"
    >
    </app-tracked-time-list-item>
  </ng-template>
</app-search-list>
